<script>
  import Modal from './Modal.svelte';
  import Button from './Button.svelte';
  import Fa from 'svelte-fa';
  import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

  export let visible;
</script>

<Modal {visible}>
  <div class="container">
    <table>
      <tr>
        <td><span style="color: red">Red</span> sparkline trend</td>
        <td>Current value is &leq; 100 (for stock), or linear regression of last 20 values indicate halving/doubling within 90 days (halving for stock, doubling for lead time and price).</td>
      </tr>
      <tr>
        <td>Lifecycle Status</td>
        <td class="bold"><span class="green">Active</span>, <span class="orange">NRND</span>, <span class="orange">EOL</span>, <span class="red">DiscontinuedAtDigiKey</span>, <span class="red">Obsolete</span>, <span class="gray">Unknown</span></td>
      </tr>
      <tr>
        <td><Fa icon={faExclamationCircle} color="red" /></td>
        <td>Decrease in good (active) vs bad (other) lifecycle statuses, or only unknown statuses and stock &lt; 5000.</td>
      </tr>
      <tr>
        <td>RoHS</td>
        <td class="bold"><span class="green">Compliant</span>, <span class="red">Non-compliant</span>, <span class="gray">Unknown</span></td>
      </tr>
    </table>
    <div class="footer">
      <div class="button"><Button on:click={() => visible = false}>Close</Button></div>
    </div>
  </div>
</Modal>

<style>
  .container {
    display: grid;
    grid-template-rows: auto min-content;
    gap: 5px;
  }

  td {
    padding: 5px;
  }

  .bold {
    font-weight: bold;
  }

  .green {
    color: green;
  }

  .orange {
    color: darkorange;
  }

  .red {
    color: red;
  }

  .gray {
    color: gray;
  }

  .footer {
    display: grid;
    justify-content: right;
  }
</style>